import { Spline3D } from "./utils/Spline3D";

export const SPLINE_WALL_INNER_1 = new Spline3D(
    true,
    [-0, -0, 102, 100, 108, 106, -0, -0],
    [-0, -0, 44, 60, 60, 44, -0, -0],
    [0, 0, 20, 20, 20, 20, 0, 0]
);

export const SPLINE_WALL_INNER_2 = new Spline3D(
    true,
    [-0, -0, 100, 100, 100, 100, 106, 106, 108, 106, -0, -0],
    [-0, -0, 20, -0, -20, -40, -40, -20, -0, 20, -0, -0],
    [0, 0, 20, 20, 20, 20, 20, 20, 20, 20, 0, 0]
);

export const SPLINE_WALL_INNER_3 = new Spline3D(
    true,
    [0, 0, 121.24000000000001, 138.56, 155.88, 173.2, 190.51999999999998, 207.83999999999997, 225.15999999999997, 242.48000000000002, 259.8, 242.48000000000002, 225.15999999999997, 207.83999999999997, 190.51999999999998, 173.2, 155.88, 138.56, 121.24000000000001, 0, 0],
    [0, 0, -70, -80, -90, -100, -90, -80, -70, -60, -50, -60, -70, -80, -90, -100, -90, -80, -70, 0, 0],
    [0, 0, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 0, 0]
);

export const SPLINE_WALL_INNER_4 = new Spline3D(
    true,
    [0, 0, 190.51999999999998, 207.83999999999997, 225.15999999999997, 242.48000000000002, 259.8, 259.8, 242.48000000000002, 225.15999999999997, 207.83999999999997, 190.51999999999998, 0, 0],
    [0, 0, 70, 80, 70, 60, 50, 50, 60, 70, 80, 70, 0, 0],
    [0, 0, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 0, 0]
);

export const SPLINE_WALL_INNER_5 = new Spline3D(
    true,
    [0, 0, 17.32, 86.6, 0, 0],
    [0, 0, -110, -70, 0, 0],
    [0, 0, 40, 40, 0, 0]
);

export const SPLINE_WALL_INNER_6 = new Spline3D(
    true,
    [0, 0, -51.959999999999994, -34.64, 17.32, 34.64, 34.64, 17.2, -17.32, -51.959999999999994, 0, 0],
    [0, 0, -30, -60, -70, -40, 0, 30, 30, 10, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
);
